import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIETag, { ETagsColorType } from '@src/shared/components/PIETag';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { globalStyles } from 'snacks-design-system';

const { xdsSpacingB } = globalStyles;

const TagPreOrder: FC = () => {
  const { t } = useTranslation();
  return (
    <PIETag mode={ETagsColorType.Information}>
      <PIEComponentUtil paddingX={xdsSpacingB}>{t('order.pre_order_tag')}</PIEComponentUtil>
    </PIETag>
  );
};

export default TagPreOrder;
